import { CALL_API } from './api'
// import moment from 'moment-timezone'
import {
    getToken
} from 'Lib'

export default store => next => action => {
    const entry = action[CALL_API]

    if (typeof entry !== 'object') return next(action)

    const isCORE = entry.types[0].startsWith("CORE")

    if (isCORE) {
        const token = getToken()
        if (!token) return next(action)
        else next(action)

        // const { expires_on, access_token } = getAllToken()
        // const currentTime = moment().format(dateTimeFormat)
        // const duration = moment.duration(moment.unix(expires_on).diff(currentTime))
        // const minutes = duration.asMinutes()

        // if (minutes < 10) {
        //     console.log('request new token')
        //     fetch(`${CORE_API_ENDPOINT}/user/refeshtoken`, {
        //         method: 'POST',
        //         headers: {
        //             'Content-Type': 'application/json'
        //         },
        //         body: JSON.stringify({ access_token })
        //     })
        //         .then(res => res.json())
        //         .then(json => setToken(json))
        //         .then(() => next(action))
        // } else {
        //     next(action)
        // }
    } else {
        next(action)
    }
}


// WEBPACK FOOTER //
// ./src/middlewares/checkToken.js